import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { BucketListItems, BucketListSuggestionForm } from "@/components/road/BucketList";

/**
 * Dedicated Bucket List page — mirrors the Landing section but on its own route.
 * Lets fans deep-link and share the full list.
 */
export default function BucketListPage() {
  return (
    <div className="min-h-screen bg-[#0A0A0A] grain" data-testid="bucket-list-page">
      <div className="max-w-5xl mx-auto px-6 py-16">
        <Link
          to="/"
          className="font-mono-tactical text-[11px] uppercase tracking-widest text-zinc-400 hover:text-[#FF4D8B] inline-flex items-center gap-2"
          data-testid="bucket-list-back-home"
        >
          <ArrowLeft size={14} /> Back to the road
        </Link>

        <div className="mt-8">
          <div className="overline mb-3">The bucket list</div>
          <h1 className="font-display text-4xl sm:text-5xl uppercase tracking-tight leading-tight">
            Things <span className="text-[#FFC107]">BooBoo</span> has to do.
          </h1>
          <p className="text-zinc-400 mt-4 max-w-2xl">
            Experiences, weird detours, strange destinations.  Not Yet → On the Route → Done. When
            an item is checked off, it hooks into the state's journey page so you can see what
            actually went down.
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-3">
          {[
            { label: "Not Yet", status: "not_yet", color: "#FFC107" },
            { label: "On the Route", status: "on_the_route", color: "#FF1E1E" },
            { label: "Done", status: "done", color: "#22C55E" },
          ].map((bucket) => (
            <div key={bucket.status} data-testid={`bucket-column-${bucket.status}`}>
              <div
                className="font-display text-lg uppercase tracking-wider mb-3 pb-2 border-b"
                style={{ color: bucket.color, borderColor: `${bucket.color}55` }}
              >
                {bucket.label}
              </div>
              <BucketListItems filterStatus={bucket.status} />
            </div>
          ))}
        </div>

        <div className="mt-14">
          <BucketListSuggestionForm />
        </div>
      </div>
    </div>
  );
}
